// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"797dbc44","239":"2bc86eec","667":"2604bac5"}[chunkId] + ".chunk.js";
};